import { DropdownFilterButton } from '@finbeat/react-toolkit';
import { faDownLong } from '@fortawesome/free-solid-svg-icons';
import { downloadBalanceDetail } from 'axios/reportApi';
import FileSaver from 'file-saver';
import useApi from 'hooks/useApi';
import { useState } from 'react';

export type ButtonReportDetailsDownloadProps = {
    items?: number[];
};

const ButtonReportDetailsDownload = ({ items = [] }: ButtonReportDetailsDownloadProps) => {
    const api = useApi();
    const [loading, setloading] = useState(false);
    return (
        <DropdownFilterButton
            onClick={async () => {
                setloading(true);
                const file = await downloadBalanceDetail(api, items);
                file && FileSaver.saveAs(new Blob([file]), `BalanceDetailExcel.xlsx`);
                setloading(false);
            }}
            icon={faDownLong}
            disabled={loading || !items.length}
            title="BackOfficeToExcel"
        />
    );
};

export default ButtonReportDetailsDownload;
